import Cookies from "js-cookie";
import React, { Fragment } from "react";
//images import
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import man from "../../../assets/images/dashboard/man.png";

const UserMenu = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <li className="onhover-dropdown">
        <div className="media align-items-center">
          <img
            className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
            src={man}
            alt="header-user"
          />
          <div className="dotted-animation">
            <span className="animate-circle"></span>
            <span className="main-circle"></span>
          </div>
        </div>
        <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/`}
              onClick={() => Cookies.remove("logss")}
              className="text-danger"
            >
              <i data-feather="log-out"></i>
              {t("Logout")}
            </Link>
          </li>
        </ul>
      </li>
    </Fragment>
  );
};

export default UserMenu;
